import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  },
  paramsSerializer: (params) => {
    const parts = []
    for (const [key, val] of Object.entries(params)) {
      if (val === null || val === undefined || val === '') continue
      if (Array.isArray(val)) {
        val.forEach((v) => parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`))
      } else {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
      }
    }
    return parts.join('&')
  }
})

// 关键坑：SSO 走网关 host-only httpOnly Cookie（oidc_access_token / oidc_refresh_token），
// 网关 SsoCookieBearerFilter 会自动把 Cookie 转成 Bearer 转发下游。
// 前端不要手动加 Authorization 头，否则网关会用该头做 JWT 校验，无效 token 会 401。
request.interceptors.request.use(
  (config) => {
    /* 组织视角注入（2026-10-15 权限隔离）：
     * 具体组织 → X-Org-Scope=<id> + organizationId 参数；全部视角 → X-Org-Scope=ALL；
     * 组织账号该头被网关忽略并强制本组织。排除登录/组织管理域。 */
    const raw = localStorage.getItem('ops_org_scope')
    const url = String(config.url || '')
    if (raw !== null && !url.startsWith('/auth') && !url.startsWith('/user/organization')) {
      config.headers = config.headers || {}
      if (raw) {
        config.headers['X-Org-Scope'] = raw
        if (String(config.method || 'get').toLowerCase() === 'get') {
          config.params = config.params || {}
          if (config.params.organizationId === undefined) config.params.organizationId = raw
        } else if (config.data && typeof config.data === 'object' && !config.data.organizationId) {
          config.data.organizationId = raw
        }
      } else {
        config.headers['X-Org-Scope'] = 'ALL'
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res && typeof res === 'object') {
      if ('success' in res) {
        if (!res.success) {
          ElMessage.error(res.message || '请求失败')
          return Promise.reject(new Error(res.message || '请求失败'))
        }
        return res.data ?? res.body ?? null
      }
      // 统一错误提示：对没有 code 字段的响应（如 {loggedIn:false}）不要误报
      if ('code' in res && res.code !== 200 && res.code !== 0) {
        const msg = res.message || res.msg || '请求失败'
        ElMessage.error(msg)
        return Promise.reject(new Error(msg))
      }
    }
    return res
  },
  (error) => {
    const status = error.response?.status
    const msg = error.response?.data?.message || error.message || '网络错误'
    if (status === 401 || status === 403) {
      // 401/403 整页跳登录（加 /api 前缀）
      const redirect = encodeURIComponent(window.location.origin + router.currentRoute.value.fullPath)
      window.location.href = '/api/auth/oidc/login?redirect=' + redirect
    } else {
      ElMessage.error(msg)
    }
    return Promise.reject(error)
  }
)

export default request
